import { clearListMemory } from '../components/list/list-memory.ts';
import { clearAllMassEditSelections } from '../components/list/mass-edit/selection-store.ts';
import { resetOrderFlow } from '../pages/order-flow.tsx';
import { clearChatDrafts } from './chat-drafts.ts';
import { clearBriefingDone } from './briefing-done.ts';
import { clearLater } from './payment-queue.ts';
import { setSidebar } from './layout.ts';
import { clearSidebarParts } from './sidebar-part.ts';
import { setTheme } from './theme.ts';

/**
 * Abmelden bzw. Personenwechsel im selben Browser (Story 1.23): alles vergessen, was die vorige Person im Browser
 * hinterlassen hat – Listen-Gedächtnis (Ansicht, Auswahl, Scrollstelle), Auswahl der Massenbearbeitung, Scrollstellen des
 * Routers, Rückgängig-Angebot, gemerkte Zeilen der Klärfälle und abgehakte Zeilen von „Heute wichtig“ und zurückgestellte Zahlungen („Später“, Story 13.8). Hell/Dunkel, Seitenleiste (schmal/breit) und Dichte gehen auf die Grundwerte zurück (sie kommen nach der Anmeldung aus dem Profil).
 */
export function clearPersonalCaches(): void {
  clearChatDrafts();
  clearListMemory();
  clearAllMassEditSelections();
  // Klärfälle nacheinander (Story 7.20): Rückgängig-Angebot, Fehler, gemerkte Auftragszeilen.
  resetOrderFlow();
  // Ticket 1.261: gemerkter Teil der Seitenleiste (Auftrag).
  clearSidebarParts();
  // Ticket 1.275: abgehakte Zeilen von „Heute wichtig“.
  clearBriefingDone();
  // Story 13.8: „Später“ in der Zahlungs-Warteschlange (nur im Browser, je Person).
  clearLater();
  setTheme('light', { persist: false });
  setSidebar('collapsed', { persist: false });
  // Dichte „Kompakt“ der vorigen Person nicht auf die Anmeldeseite mitnehmen (Grundwert „Ruhig“; nach der Anmeldung aus dem Profil).
  delete document.documentElement.dataset.density;
  try {
    for (const key of Object.keys(sessionStorage)) if (key.startsWith('tsr-scroll-restoration')) sessionStorage.removeItem(key);
  } catch {
    // Ohne Speicher gibt es nichts zu löschen.
  }
}
